export const fontSizeTokens = {
    smallest: '12px',
    smaller: '14px',
    small: '16px',
    medium: '20px',
    large: '24px',
    larger: '32px',
    largest: '48px'
};
